// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".point-table-row{margin-bottom:1px}.emphasized .table-row-left{background:#f7bcf0}.emphasized .table-row-right{background:#fdf1ff;color:red}.emphasized .table-row-left:after{border-left:10px solid #f7bcf0}", ""]);
// Exports
module.exports = exports;
